import { render } from "./notification.vue?vue&type=template&id=14f11783"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroAdmin\\marriage_beauro_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__